import * as React from 'react';
import { StyleSheet } from 'aphrodite/no-important';
import { TYPOGRAPHY_SIZE } from 'mm-theme-configuration/dist/consts';
import { MandatoryAdditionalStyle } from '../components.utils';
import { useTheme } from '../../theming/useTheme';
import { ErrorBoundary } from '../errorHandling/ErrorBoundary';
import { H3, Span, semanticCSS } from '../../typography/semanticTags';
import { SemanticTagThemeProps, getStyleBySize } from '../../typography/semanticTags/semanticTags.utils';
import { BaseUnit } from '../../theming/baseUnitDefinition';

const componentConfigurationKey = 'listItemTitle';

interface ListItemTitleComponentDataProps {
  listItemNumber: string;
  text: string;
  dataId?: string;
}

interface ListItemTitleComponentThemeProps extends SemanticTagThemeProps {
  titleColor: string;
  numberColor: string;
  baseUnit: BaseUnit;
}

const getStyle = (theme: ListItemTitleComponentThemeProps) => StyleSheet.create({
  numberStyle: {
    color: theme.numberColor,
  },
  titleStyle: {
    color: theme.titleColor,
  },
});

export const ListItemTitle: React.FunctionComponent<ListItemTitleComponentDataProps & MandatoryAdditionalStyle> = props => {
  const { listItemNumber, text, additionalStyle, dataId } = props;
  const themeProps = useTheme<ListItemTitleComponentThemeProps>(componentConfigurationKey);
  const { fontSizesStyles } = themeProps;
  const { numberStyle, titleStyle } = getStyle(themeProps);
  const contentStyle = getStyleBySize(fontSizesStyles, { fontSizeSmall: TYPOGRAPHY_SIZE.LARGE, fontSizeMedium: TYPOGRAPHY_SIZE.LARGE, fontSizeLarge: TYPOGRAPHY_SIZE.LARGE });

  return (
    <ErrorBoundary>
      <H3 data-id={dataId} styles={semanticCSS(additionalStyle.style, titleStyle)}>
        <Span styles={semanticCSS(numberStyle, contentStyle)}>
          {`${listItemNumber}. `}
        </Span>
        {text}
      </H3>
    </ErrorBoundary>
  );
};
